// @flow
import React from "react";
import {ProgressBarSVG, ProgressContainer} from "./ProgressBarStyle";

type OwnProps = {
    progress: number;
    maxProgress: number;
    fill?: string;
    finishHandler?: () => mixed;
}

const ProgressBar = (props: OwnProps = {
    progress: 50,
    maxProgress: 100,
    fill: `red`,
}) => {
    return (
        <ProgressContainer>
            <ProgressBarSVG preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 100 100">
                <path d={`M0 0 h ${props.maxProgress - props.progress} v 100 h ${props.progress - props.maxProgress}`}
                      style={{fill: props.fill}}/>
            </ProgressBarSVG>
        </ProgressContainer>
    );
};
export default ProgressBar;


// WEBPACK FOOTER //
// ./src/Components/ProgressBar/ProgressBar.js